import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";
import { ReactElement } from "react";

export default function Error404Svg({
    sx,
    ...rest
}: SvgIconProps): ReactElement {
    const theme = useTheme();
    const color = theme.palette.primary.main;
    return (
        <SvgIcon
            viewBox="0 0 234 235"
            sx={{ width: 234, height: 235, ...sx }}
            {...rest}
        >
            <path
                d="M117.431 234.324C181.489 234.324 233.418 181.869 233.418 117.162C233.418 52.4553 181.489 0 117.431 0C53.3733 0 1.44434 52.4553 1.44434 117.162C1.44434 181.869 53.3733 234.324 117.431 234.324Z"
                fill="url(#paint0_linear_23981_6396)"
                fillOpacity="0.5"
            />
            <path
                d="M75.1803 122.581C75.4977 122.581 75.7923 122.263 76.0644 121.629C76.3817 120.994 76.5404 119.951 76.5404 118.501V116.121H51.0404C51.403 115.531 51.9017 114.738 52.5364 113.741C53.2164 112.743 53.8737 111.814 54.5084 110.953C55.3244 109.819 56.3217 108.369 57.5004 106.601C58.7244 104.787 60.0164 102.815 61.3764 100.685C62.7817 98.5539 64.1644 96.4006 65.5244 94.2246C66.9297 92.0486 68.2444 90.0086 69.4684 88.1046C70.919 85.8832 71.803 84.2966 72.1204 83.3446C72.4377 82.3472 72.483 81.8259 72.2564 81.7806H88.3043C87.987 81.7806 87.6697 82.0979 87.3523 82.7326C87.0804 83.3672 86.9444 84.4326 86.9444 85.9286L86.8763 108.641H87.6243C90.299 108.641 92.4297 108.482 94.0163 108.165C95.6483 107.847 96.691 107.53 97.1443 107.213L95.7843 114.081V116.121H86.8763V118.501C86.8763 119.951 87.035 120.994 87.3523 121.629C87.6697 122.263 87.987 122.581 88.3043 122.581H75.1803ZM66.5444 108.641H76.5404V91.3686H76.4043C76.0417 92.3659 75.5657 93.4992 74.9764 94.7686C74.4324 95.9926 73.7977 97.2619 73.0724 98.5766C72.347 99.8912 71.599 101.183 70.8284 102.453C70.0577 103.677 69.3097 104.81 68.5843 105.853C67.859 106.895 67.179 107.757 66.5444 108.437V108.641ZM118.581 123.261C112.551 123.261 108.041 121.47 105.049 117.889C102.057 114.262 100.561 108.958 100.561 101.977C100.561 95.1766 102.079 90.0086 105.117 86.4726C108.154 82.8912 112.642 81.1006 118.581 81.1006H119.329C125.177 81.1006 129.574 82.8686 132.521 86.4046C135.513 89.9406 137.009 95.1312 137.009 101.977C137.009 108.958 135.513 114.262 132.521 117.889C129.574 121.47 125.177 123.261 119.329 123.261H118.581ZM118.581 115.713H119.329C120.87 115.713 122.185 115.327 123.273 114.557C124.361 113.741 125.199 112.335 125.789 110.341C126.378 108.346 126.673 105.558 126.673 101.977C126.673 98.4859 126.378 95.7886 125.789 93.8846C125.199 91.9352 124.361 90.5752 123.273 89.8046C122.185 88.9886 120.87 88.5806 119.329 88.5806H118.581C117.039 88.5806 115.679 88.9659 114.501 89.7366C113.367 90.5072 112.483 91.8672 111.849 93.8166C111.214 95.7206 110.897 98.4406 110.897 101.977C110.897 105.603 111.214 108.414 111.849 110.409C112.483 112.403 113.367 113.786 114.501 114.557C115.679 115.327 117.039 115.713 118.581 115.713ZM164.563 122.581C164.88 122.581 165.175 122.263 165.447 121.629C165.764 120.994 165.923 119.951 165.923 118.501V116.121H140.423C140.786 115.531 141.284 114.738 141.919 113.741C142.599 112.743 143.256 111.814 143.891 110.953C144.707 109.819 145.704 108.369 146.883 106.601C148.107 104.787 149.399 102.815 150.759 100.685C152.164 98.5539 153.547 96.4006 154.907 94.2246C156.312 92.0486 157.627 90.0086 158.851 88.1046C160.302 85.8832 161.186 84.2966 161.503 83.3446C161.82 82.3472 161.866 81.8259 161.639 81.7806H177.687C177.37 81.7806 177.052 82.0979 176.735 82.7326C176.463 83.3672 176.327 84.4326 176.327 85.9286L176.259 108.641H177.007C179.682 108.641 181.812 108.482 183.399 108.165C185.031 107.847 186.074 107.53 186.527 107.213L185.167 114.081V116.121H176.259V118.501C176.259 119.951 176.418 120.994 176.735 121.629C177.052 122.263 177.37 122.581 177.687 122.581H164.563ZM155.927 108.641H165.923V91.3686H165.787C165.424 92.3659 164.948 93.4992 164.359 94.7686C163.815 95.9926 163.18 97.2619 162.455 98.5766C161.73 99.8912 160.982 101.183 160.211 102.453C159.44 103.677 158.692 104.81 157.967 105.853C157.242 106.895 156.562 107.757 155.927 108.437V108.641Z"
                fill="url(#paint1_linear_23981_6396)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.4503 170.926C26.9817 170.926 32.3831 168.81 36.8249 164.54C42.1388 159.432 45.2146 152.172 48.1888 145.151C51.5507 137.215 54.7265 129.719 60.5265 127.843C63.0818 127.017 65.4059 127.295 67.6315 128.694C77.4169 134.845 81.1257 159.336 81.1632 159.582L84.4703 159.085C84.3124 158.015 80.4833 132.794 69.3991 125.825C66.3327 123.898 63.0053 123.495 59.5075 124.626C52.254 126.972 48.7859 135.156 45.1161 143.822C39.4115 157.287 33.5146 171.211 12.9858 166.66L3.05503 163.414C2.17667 163.127 1.23424 163.613 0.949786 164.5C0.665336 165.387 1.14828 166.339 2.02663 166.627L12.1871 169.941C15.1223 170.597 17.8746 170.926 20.4503 170.926Z"
                fill="#666666"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M76.9492 187.605L73.392 170.18C72.1635 164.164 75.6332 158.18 81.4301 156.32C87.9162 154.24 94.8023 158.076 96.5215 164.727L100.887 181.628L76.9492 187.605Z"
                fill="url(#paint2_linear_23981_6396)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M76.9577 188.066C77.3406 189.67 83.0765 189.65 89.7704 188.021C96.4644 186.391 101.581 183.772 101.198 182.168C100.816 180.564 95.0796 180.585 88.3857 182.214C81.6917 183.843 76.5747 186.462 76.9577 188.066Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M91.4079 183.338C91.3126 183.879 92.2691 184.506 93.546 184.737C94.8229 184.969 95.9372 184.718 96.0326 184.176C96.1295 183.635 95.1714 183.008 93.8945 182.777C92.6176 182.547 91.5048 182.798 91.4079 183.338Z"
                fill="#CBCBCB"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M82.9733 185.951C82.878 186.492 83.8345 187.119 85.113 187.35C86.3899 187.582 87.5042 187.331 87.5996 186.789C87.6965 186.248 86.7384 185.622 85.4599 185.39C84.183 185.16 83.0702 185.411 82.9733 185.951Z"
                fill="#CBCBCB"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M87.668 158.362C87.668 158.362 92.8287 160.258 94.4713 165.708C96.1139 171.159 97.5221 178.15 97.5221 178.15L92.8303 178.268L87.668 158.362Z"
                fill="#BBD1F5"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M83.1227 152.186L80.6299 156.584L83.9151 155.814L83.1227 152.186Z"
                fill="#666666"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M233.745 147.584L232.415 150.57C232.184 150.466 226.695 147.892 221.656 138.833C220.199 136.214 217.964 133.15 215.595 133.433C213.895 133.635 209.386 136.075 204.258 154.305C198.666 174.186 186.706 187.176 168.711 192.914C157.064 196.627 142.66 188.7 142.054 188.361L143.621 185.495C143.803 185.596 157.441 193.073 167.736 189.791C184.626 184.406 195.865 172.164 201.141 153.408C205.361 138.404 209.965 130.805 215.215 130.18C218.541 129.784 221.659 132.155 224.482 137.228C229.006 145.36 233.698 147.562 233.745 147.584Z"
                fill="#666666"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M113.552 173.586L122.089 179.835C122.802 180.358 122.961 181.365 122.445 182.085C121.928 182.805 120.931 182.966 120.218 182.443L111.681 176.194C110.969 175.672 110.809 174.665 111.325 173.945C111.842 173.225 112.84 173.064 113.552 173.586Z"
                fill="#CBCBCB"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M120.139 164.016L128.675 170.265C129.388 170.787 129.548 171.794 129.032 172.514C128.514 173.234 127.517 173.395 126.805 172.874L118.268 166.626C117.555 166.103 117.396 165.096 117.913 164.376C118.427 163.654 119.425 163.493 120.139 164.016Z"
                fill="#CBCBCB"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M150.004 188.879L144.706 189.676L146.172 186.692L151.181 188.686L150.004 188.879Z"
                fill="#666666"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M114.202 182.526L128.97 192.223C134.07 195.572 140.848 194.489 144.677 189.715C148.96 184.372 147.933 176.496 142.427 172.456L128.437 162.189L114.202 182.526Z"
                fill="url(#paint3_linear_23981_6396)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M119.154 183.237L122.554 178.589L139.996 191.279C139.996 191.279 135.817 193.384 131.003 191.02C126.189 188.659 119.154 183.237 119.154 183.237Z"
                fill="#BBD1F5"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_23981_6396"
                    x1="117.431"
                    y1="-3.44005e-08"
                    x2="116.848"
                    y2="170.26"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={color} stopOpacity="0.5" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_23981_6396"
                    x1="118.86"
                    y1="58.5806"
                    x2="119"
                    y2="123"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={color} />
                    <stop offset="1" stopColor="#C0D5FF" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_23981_6396"
                    x1="87.0161"
                    y1="155.753"
                    x2="87.0161"
                    y2="187.605"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={color} />
                    <stop offset="1" stopColor="#C0D5FF" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_23981_6396"
                    x1="130.764"
                    y1="162.189"
                    x2="130.764"
                    y2="194.163"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={color} />
                    <stop offset="1" stopColor="#C0D5FF" />
                </linearGradient>
            </defs>{" "}
        </SvgIcon>
    );
}
